<template>
	<v-container class="main-wrapper">
		<div class="field-wrapper">
			<v-textarea
					v-model="getNotes"
					label="Notes"
					:disabled="editableNote"
					class="field textarea"
					rows="5"
					dense
					prepend-icon="mdi-comment"
			></v-textarea>
		</div>
	</v-container>
</template>
<script>

export default {
	props: {
		permissions: Object,
		getNote: String,
		editableNote: {
			type: Boolean,
			default: () => false
		}
	},
	computed: {
		getNotes: {
			get: function() {
				return this.getNote;
			},
			set: function(val) {
				this.$emit("on", val);
			}
		},
		cities() {
			return this.$store.getters.getCitiesList;
		},
	},
};
</script>
<style lang="scss" scoped>
@import "FactoringCreate";
</style>
